import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Quadrant, Tooth } from '@libs/ui-lib';
import { CommonModule } from '@angular/common';
import { SelectedCompare } from '../perio-screen';
import { PocketDepthTableComponent } from '../perio-compare/pocket-depth/pocket-depth-table/pocket-depth-table.component';
import { fadeInOnly, fadeInOnlyDelayed, fadeInOut } from '../../common/animations';

@Component({
  selector: 'lib-perio-compare-overlay',
  standalone: true,
  templateUrl: './perio-compare-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, PocketDepthTableComponent],
  animations: [fadeInOut, fadeInOnly, fadeInOnlyDelayed],
})
export class PerioCompareOverlayComponent {
  @Input() public compareSelected: SelectedCompare | null = null;
  @Input() public selectedQuadrant: Quadrant | null = null;

  @Input() public currentTopRightTeeth: Tooth[] = [];
  @Input() public currentTopLeftTeeth: Tooth[] = [];
  @Input() public currentBottomLeftTeeth: Tooth[] = [];
  @Input() public currentBottomRightTeeth: Tooth[] = [];
  @Input() public currentSelectedQuadrantTeeth: Tooth[] = [];

  @Input() public previousTopRightTeeth: Tooth[] = [];
  @Input() public previousTopLeftTeeth: Tooth[] = [];
  @Input() public previousBottomLeftTeeth: Tooth[] = [];
  @Input() public previousBottomRightTeeth: Tooth[] = [];
  @Input() public previousSelectedQuadrantTeeth: Tooth[] = [];

  protected SelectedCompare = SelectedCompare;
  protected Quadrant = Quadrant;
}
